import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { invalidateResource } from "kea-resource";

import { columnas } from "./columnas";

type Entity = models.CargaDescargaCajaRutaDto;
export interface Props {
    value: Entity[];
    readonly?: boolean;
}

/**
* Listado de CargaDescargaCajaRutaDto
*/
class CargaDescargaCajaRutaDtoListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    onVer = async (x: Entity) => {
        await history.go(`/operativa/cargasdescargas/${x.IdRegistro}/`);
    }

    onCancelar = async (x: Entity) => {
        if (await kea.yesno("Cancelar carga/descarga", `¿Cancelar el proceso "${models.TipoCargaDescarga[x.Tipo]}" de la caja ${x.NombreCaja}?`)) {
            await resources.CargaDescarga.CancelarCargaDescarga(x.IdRegistro);
        }
    }

    onReabrir = async (x: Entity) => {
        if (await kea.yesno("Reabrir carga/descarga", `Reabrir el proceso "${models.TipoCargaDescarga[x.Tipo]}" de la caja ${x.NombreCaja}?` + "'\nEsta operación puede ocasionar problemas con la historia de los status de las guías")) {
            await resources.CargaDescarga.ReabrirCargaDescarga(x.IdRegistro);
        }
    }

    render() {
        const cols = columnas(this);
        return (
            <div>

                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const CargaDescargaCajaRutaDtoList = kea.mapProps(componentToRx(CargaDescargaCajaRutaDtoListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/list/cargasdescargas/list.tsx